// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReviewPage-page-oGYUd {
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}
.ReviewPage-wrap-lzEqw {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}
.ReviewPage-hero-SUFF8 {
  background: radial-gradient(circle at 85% 12%, #fff6ec, transparent 45%), #fafbfc;
  border-bottom: 1px solid var(--line);
  padding: 56px 0 44px;
  text-align: center;
}
.ReviewPage-stars-AaHAB {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 4px;
  margin-bottom: 16px;
}
.ReviewPage-stars-AaHAB svg {
  width: 26px;
  height: 26px;
}
.ReviewPage-h1-HoUQA {
  font-size: clamp(28px, 5vw, 42px);
  font-weight: 800;
  margin: 0 0 12px;
}
.ReviewPage-sub-jXFFB {
  font-size: clamp(16px, 2.2vw, 19px);
  color: var(--muted);
  max-width: 560px;
  margin: 0 auto;
  line-height: 1.55;
}
.ReviewPage-grid-lKEAf {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 44px 0 8px;
}
.ReviewPage-card-agizc {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  text-align: center;
}
/* Featured (Trustpilot) — highlighted, spans full row so it sits prominently on top. */
.ReviewPage-cardFeatured-h4a9R {
  border: 2px solid #00b67a;
  background: #f2fbf8;
  grid-column: 1 / -1;
}
.ReviewPage-card-agizc h2 {
  font-size: 20px;
  font-weight: 800;
  margin: 0 0 6px;
}
.ReviewPage-card-agizc p {
  font-size: 15px;
  color: var(--muted);
  margin: 0 0 18px;
}
.ReviewPage-btns-VLPEU {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 12px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.ReviewPage-btn-tbw9T {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: #16a34a;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 15px;
  padding: 11px 20px;
  border-radius: 12px;
  min-width: 130px;
  -webkit-transition: background 0.15s, -webkit-transform 0.15s;
  transition: background 0.15s, -webkit-transform 0.15s;
  transition: background 0.15s, transform 0.15s;
  transition: background 0.15s, transform 0.15s, -webkit-transform 0.15s;
}
.ReviewPage-btn-tbw9T:hover {
  background: #0f7a37;
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}
.ReviewPage-btnGoogle-z6Xn3 {
  background: #4285f4;
}
.ReviewPage-btnGoogle-z6Xn3:hover {
  background: #2f6fe0;
}
.ReviewPage-foot-f4BSv {
  text-align: center;
  font-size: 14px;
  color: var(--muted);
  padding: 28px 0 64px;
}
.ReviewPage-foot-f4BSv a {
  color: #16a34a;
  font-weight: 600;
  text-decoration: none;
}
@media (max-width: 600px) {
  .ReviewPage-grid-lKEAf {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/leave-a-review/ReviewPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iFAAiF;EACjF,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,uFAAuF;AACvF;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".page {\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n.wrap {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n.hero {\n  background: radial-gradient(circle at 85% 12%, #fff6ec, transparent 45%), #fafbfc;\n  border-bottom: 1px solid var(--line);\n  padding: 56px 0 44px;\n  text-align: center;\n}\n.stars {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n.stars svg {\n  width: 26px;\n  height: 26px;\n}\n.h1 {\n  font-size: clamp(28px, 5vw, 42px);\n  font-weight: 800;\n  margin: 0 0 12px;\n}\n.sub {\n  font-size: clamp(16px, 2.2vw, 19px);\n  color: var(--muted);\n  max-width: 560px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  padding: 44px 0 8px;\n}\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  text-align: center;\n}\n/* Featured (Trustpilot) — highlighted, spans full row so it sits prominently on top. */\n.cardFeatured {\n  border: 2px solid #00b67a;\n  background: #f2fbf8;\n  grid-column: 1 / -1;\n}\n.card h2 {\n  font-size: 20px;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.card p {\n  font-size: 15px;\n  color: var(--muted);\n  margin: 0 0 18px;\n}\n.btns {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #16a34a;\n  color: #fff;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 15px;\n  padding: 11px 20px;\n  border-radius: 12px;\n  min-width: 130px;\n  transition: background 0.15s, transform 0.15s;\n}\n.btn:hover {\n  background: #0f7a37;\n  transform: translateY(-2px);\n}\n.btnGoogle {\n  background: #4285f4;\n}\n.btnGoogle:hover {\n  background: #2f6fe0;\n}\n.foot {\n  text-align: center;\n  font-size: 14px;\n  color: var(--muted);\n  padding: 28px 0 64px;\n}\n.foot a {\n  color: #16a34a;\n  font-weight: 600;\n  text-decoration: none;\n}\n@media (max-width: 600px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ReviewPage-page-oGYUd`,
	"wrap": `ReviewPage-wrap-lzEqw`,
	"hero": `ReviewPage-hero-SUFF8`,
	"stars": `ReviewPage-stars-AaHAB`,
	"h1": `ReviewPage-h1-HoUQA`,
	"sub": `ReviewPage-sub-jXFFB`,
	"grid": `ReviewPage-grid-lKEAf`,
	"card": `ReviewPage-card-agizc`,
	"cardFeatured": `ReviewPage-cardFeatured-h4a9R`,
	"btns": `ReviewPage-btns-VLPEU`,
	"btn": `ReviewPage-btn-tbw9T`,
	"btnGoogle": `ReviewPage-btnGoogle-z6Xn3`,
	"foot": `ReviewPage-foot-f4BSv`
};
module.exports = ___CSS_LOADER_EXPORT___;
